var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordOpenEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.74927C4.5 5.74927 1.5 12.5 1.5 12.5C1.5 12.5 4.5 19.2493 12 19.2493C19.5 19.2493 22.5 12.5 22.5 12.5C22.5 12.5 19.5 5.74927 12 5.74927Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.2501C14.0711 16.2501 15.75 14.5711 15.75 12.5001C15.75 10.429 14.0711 8.75006 12 8.75006C9.92893 8.75006 8.25 10.429 8.25 12.5001C8.25 14.5711 9.92893 16.2501 12 16.2501Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordOpenEyeIcon);
export default __webpack_public_path__ + "static/media/passwordOpenEyeIcon.ccf6722eb76b0ddefe8a55ba07f24d08.svg";
export { ForwardRef as ReactComponent };